'use strict';

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _clsx = require('clsx');

var _clsx2 = _interopRequireDefault(_clsx);

var _Avatar = require('./Avatar.style');

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Avatar = (_dec = (0, _reactJss2["default"])(_Avatar2["default"]), _dec(_class = function (_PureComponent) {
  (0, _inherits3["default"])(Avatar, _PureComponent);

  function Avatar(props) {
    (0, _classCallCheck3["default"])(this, Avatar);

    var _this = (0, _possibleConstructorReturn3["default"])(this, (Avatar.__proto__ || (0, _getPrototypeOf2["default"])(Avatar)).call(this, props));

    _this.state = {
      imageError: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  (0, _createClass3["default"])(Avatar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.src) {
        this.setImage(this.props.src);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.src !== this.props.src) {
        this.setImage(nextProps.src);
      }
    }
  }, {
    key: 'setImage',
    value: function setImage(src) {
      var _this2 = this;

      var hdLoaderImg = new Image();

      hdLoaderImg.onload = function () {
        if (_this2.avatarEl) {
          _this2.avatarEl.setAttribute('style', 'background-image: url(\'' + src + '\')');

          _this2.setState({
            imageError: false
          });
        }
      };

      hdLoaderImg.onerror = function () {
        _this2.avatarEl.setAttribute('style', '');

        _this2.setState({
          imageError: true
        });
      };

      hdLoaderImg.src = src;
    }
  }, {
    key: 'getInitials',
    value: function getInitials(label) {
      if (!label) return '';
      return label.trim().split(/\s+/).map(function (n) {
        return n[0] ? n[0].toUpperCase() : '';
      }).splice(0, 2).join('');
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var onClick = this.props.onClick;
      onClick();
    }
  }, {
    key: 'renderInitials',
    value: function renderInitials() {
      var label = this.props.label;
      return _react2["default"].createElement('span', null, this.getInitials(label));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          classes = _props.classes,
          size = _props.size,
          badge = _props.badge,
          id = _props.id,
          src = _props.src,
          bgColor = _props.bgColor,
          textColor = _props.textColor,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave;
      var imageError = this.state.imageError;
      var baseClasses = (0, _clsx2["default"])(className, classes.avatar, classes[size]);
      return _react2["default"].createElement('div', {
        id: id,
        ref: function ref(el) {
          return _this3.avatarEl = el;
        },
        className: baseClasses,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        style: {
          backgroundColor: bgColor,
          color: textColor
        },
        onClick: this.handleClick
      }, children || (!src || imageError) && this.renderInitials(), badge && _react2["default"].cloneElement(badge, {
        className: 'status'
      }));
    }
  }]);
  return Avatar;
}(_react.PureComponent)) || _class);
Avatar.defaultProps = {
  size: 'medium',
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  children: null,
  badge: null
};
Avatar.propTypes = {
  classes: _propTypes2["default"].object,

  /** additional external class name */
  className: _propTypes2["default"].string,

  /** avatar size */
  size: _propTypes2["default"].oneOf(['small', 'medium', 'large', 'xlarge', 'xxlarge']),

  /** label */
  label: _propTypes2["default"].string,

  /** element id */
  id: _propTypes2["default"].string,

  /** avatar image src */
  src: _propTypes2["default"].string,

  /** callback onClick */
  onClick: _propTypes2["default"].func,

  /** color text if no image */
  textColor: _propTypes2["default"].string,

  /** color avatar if no image */
  bgColor: _propTypes2["default"].string,

  /** Avatar's inner node */
  children: _propTypes2["default"].node,

  /** Badge for status  */
  badge: _propTypes2["default"].node,

  /** callback onMouseEnter */
  onMouseEnter: _propTypes2["default"].func,

  /** callback onMouseLeave */
  onMouseLeave: _propTypes2["default"].func
};
exports["default"] = Avatar;